var map = {
	"./africa": 580,
	"./africa.js": 580,
	"./australia": 669,
	"./australia.js": 669,
	"./bangladesh": 670,
	"./bangladesh.js": 670,
	"./global": 671,
	"./global.js": 671,
	"./india": 672,
	"./india.js": 672,
	"./newzealand": 673,
	"./newzealand.js": 673,
	"./pakistan": 674,
	"./pakistan.js": 674,
	"./srilanka": 675,
	"./srilanka.js": 675,
	"./taboola": 667,
	"./taboola.js": 667,
	"./unitedkingdom": 676,
	"./unitedkingdom.js": 676,
	"./unitedstates": 677,
	"./unitedstates.js": 677
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 579;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config/cricinfo ^\.\/.*$
// module id = 579
// module chunks = 0